import { Flex, Heading, Image, Link } from "@chakra-ui/react"

import './styles/Footer.css';

function Footer(props: any) {

  return (
    <div>
        {/* Desktop only view */}
        <Flex className="footer__parent" justify='space-between'>
            <Flex justify='left'>
                <Link href='#'>
                    <Image height='25px' src={'/logo.png'}/>
                </Link>
            </Flex>
            <Flex direction='column' justifyContent='right' gap='4' textAlign='right'>
                <Heading color='black' size='sm'>
                {/* #d3d3d3 */}
                    Support
                </Heading>
                <Link color='gray' justifyContent='right' textAlign='right' href='#howdoesitwork'>
                    How does it Work?
                </Link>
                <Link color='gray' justifyContent='right' textAlign='right' href='#testimonials'>
                    Testimonials
                </Link>
                <Link color='gray' justifyContent='right' textAlign='right' href='#commissioncalculator'>
                    Commission Calculator
                </Link>
                <Link color='gray' justifyContent='right' textAlign='right' href='#faq'>
                    FAQ
                </Link>
                <Link color='gray' justifyContent='right' textAlign='right' href='#contactus'>
                    Contact Us
                </Link>
            </Flex>
        </Flex>

        {/* Mobile only view */}
        <Flex className="footer__mobile_parent" justify='space-between'>
            <Link href='#'>
                <Image height='20px' src={'/logo.png'}/>
            </Link>
            <Flex style={{marginTop: '25px'}}>
                <Flex direction='column' justifyContent='left' gap='4' textAlign='left'>
                    <Heading color='black' size='sm'>
                    {/* #d3d3d3 */}
                        Support
                    </Heading>
                    <Link color='gray' justifyContent='left' textAlign='left' href='#howdoesitwork'>
                        How does it Work?
                    </Link>
                    <Link color='gray' justifyContent='left' textAlign='left' href='#testimonials'>
                        Testimonials
                    </Link>
                    <Link color='gray' justifyContent='left' textAlign='left' href='#commissioncalculator'>
                        Commission Calculator
                    </Link>
                    <Link color='gray' justifyContent='left' textAlign='left' href='#faq'>
                        FAQ
                    </Link>
                    <Link color='gray' justifyContent='left' textAlign='left' href='#contactus'>
                        Contact Us
                    </Link>
                </Flex>
            </Flex>
        </Flex>
    </div>
  );
}

export default Footer;
